<template>
  <div class="md-layout text-center">
    <div
      class="
        md-layout-item
        md-size-33
        md-medium-size-50
        md-small-size-70
        md-xsmall-size-100
      "
    >
      <md-card>
        <md-bage><h3>Почтовый ящик подтверждён</h3></md-bage>
        <md-button href="#/login/" class="md-simple md-success md-lg"
          >Войти</md-button
        >
      </md-card>
    </div>
  </div>
</template>
<script>
export default {};
</script>

<style></style>
